import { render, staticRenderFns } from "./IbAssign.vue?vue&type=template&id=2e445a0f"
import script from "./IbAssign.vue?vue&type=script&lang=js"
export * from "./IbAssign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports